import { useEventContext } from "../../contexts/EventContextProvider";
import { editTagEvent, getDeleteTagEvent } from "../../events/TagEvents";

const getStateColor = (tags, id) => {
    if(tags && tags[id]){
        switch(true){
            case tags[id].deleted:
                return 'CollectionList_DeletedRow';
            case tags[id].error:
                return 'CollectionList_ErrordRow';
            default:
                return null;
        }
    }
};
const TagsListItem = ({ items, editAction, deleteAction }) => {

    const { state, eventDispatch } = useEventContext();

    return (
        <div className="filter-list">
            {items &&
                items.map((item) => {

                    var backgroundColor = getStateColor(state?.tags, item.id);

                    return (
                        <div key={`sticker-${item.id}`} className={`StickerItem ${backgroundColor}`}>
                            <div className="flex-row">
                                <div className="col-6">
                                    <div className="StickerItem_tag">
                                        <em style={{ backgroundColor: `${item.color || '#ffffff'}` }}></em><span style={{ border: `5px solid ${item.color || '#ffffff'}` }}>{item.name}</span>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <p>{item.description}</p>
                                </div>
                                <div className="col-6">
                                    <div className='StickerItem_box'>
                                        <div className="StickerItem_controls" >
                                            <button onClick={(e) => eventDispatch(editTagEvent(item.id))}><span>edit</span></button>
                                            <button onClick={(e) => eventDispatch(getDeleteTagEvent(item.id))}><span>delete</span></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
        </div>
    );
}

export default TagsListItem;